import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridDataResult } from '@progress/kendo-angular-grid';
import {
  ValidationResultService,
  MessageService,
  LoaderService,
} from '@shared';
import { CategoryService, AlertsService } from '@shared-data';
import { GridRowKidMealChangeset } from '../../models';
import { RestaurantItemService } from '../../services';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';

@Component({
  selector: 'app-kid-meal-changeset',
  templateUrl: './kid-meal-changeset.component.html',
  styleUrl: './kid-meal-changeset.component.scss',
})
export class KidMealChangesetComponent extends BasePricingChangesetComponent {
  currentComponentId: number | null = null;

  override _fontSize: number = 0.75;
  constructor(
    validationResultService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    restaurantItemsService: RestaurantItemService,
    categoryService: CategoryService,
    injector: Injector,
    activatedRoute: ActivatedRoute,
  ) {
    super(
      validationResultService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowKidMealChangeset,
    );
  }

  override setInitialSort(): void {
    this.initialSort = [
      { field: 'categoryOrder', dir: 'asc' },
      { field: 'sortOrder', dir: 'asc' },
    ];
  }

  override populateGrid(gridDataResult: GridDataResult): void {
    gridDataResult.data = gridDataResult.data.map((row) => {
      const gridRow = new GridRowKidMealChangeset(row);
      gridRow.locked =
        this.locked ||
        (gridRow.isTwoItemCombo ?? false) ||
        (gridRow.entreeOverridden ?? false) ||
        gridRow.availabilityScheduledDate != null ||
        gridRow.pricingScheduledDate != null;

      return gridRow;
    });

    this.changeset = gridDataResult;
  }

}
